// extracted by mini-css-extract-plugin
var _1 = "ZitzH9DkVhYQHTEaSImx";
var _2 = "AxLP78TNDWDzujAkxazn";
export { _1 as "dropdown", _2 as "groupLabel" }
